import React from "react";
import PropTypes from "prop-types";

import CarTypeDropdown from "./CarTypeDropdown";
import PricesBlock from "./PricesBlock";

const RatesView = ({
  averagePrice,
  minPrice,
  maxPrice,
  carType,
  carTypes,
  tonnageLabel,
  onCarTypeChange,
  analyticsHref,
  t,
}) => (
  <div className="averageRates">
    <div className="averageRates__title">{t("trace-average-rates-title", "Средние ставки ATI.SU")}</div>
    <div className="averageRates__filters">
      <span>{tonnageLabel}</span>
      <CarTypeDropdown carType={carType} carTypes={carTypes} onCarTypeChange={onCarTypeChange} t={t} />
      <span className="averageRates__nds">{t("trace-average-rates-with-nds", "с НДС")}</span>
    </div>
    <PricesBlock averagePrice={averagePrice} minPrice={minPrice} maxPrice={maxPrice} t={t} />
    <div className="averageRates__divider" />
    <a className="glz-link glz-is-medium glz-is-primary" href={analyticsHref}>
      {t("trace-average-rates-analytics-link", "Перейти к расширенной аналитике")}
    </a>
  </div>
);

RatesView.propTypes = {
  averagePrice: PropTypes.number,
  minPrice: PropTypes.number,
  maxPrice: PropTypes.number,
  carType: PropTypes.string.isRequired,
  carTypes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      labelKey: PropTypes.string.isRequired,
      shortLabelKey: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  tonnageLabel: PropTypes.string.isRequired,
  onCarTypeChange: PropTypes.func,
  analyticsHref: PropTypes.string,
  t: PropTypes.func.isRequired,
};

RatesView.defaultProps = {
  averagePrice: null,
  minPrice: null,
  maxPrice: null,
  onCarTypeChange: () => {},
  analyticsHref: "#",
};

export default RatesView;
